type SummaryRefreshVisibilityInput = {
  hasActiveContact: boolean;
  hasActiveConversation: boolean;
  callLogCount: number;
  conversationMessageCount: number;
  conversationEventCount: number;
};

type ColumnDropHintInput = {
  columnId: string;
  itemCount: number;
  activeDraggedWidgetId: string | null;
  sourceColumnId: string | null;
};

export function shouldShowSummaryRefresh(input: SummaryRefreshVisibilityInput): boolean {
  if (!input.hasActiveContact || !input.hasActiveConversation) return false;
  if (input.callLogCount <= 0) return false;
  return input.conversationMessageCount > 0 || input.conversationEventCount > 0;
}

export function shouldShowColumnDropHint(input: ColumnDropHintInput): boolean {
  if (input.itemCount > 0) return false;
  if (!input.activeDraggedWidgetId) return false;
  if (!input.sourceColumnId) return false;
  return input.sourceColumnId !== input.columnId;
}
